type AuthEventType = 'session-expired' | 'session-refreshed' | 'session-error';

type AuthEventCallback = () => void;

/**
 * Sistema de eventos para autenticación.
 * Permite comunicación entre interceptores de axios y componentes React
 * sin depender de window.location.href
 */
class AuthEventEmitter {
  private listeners: Map<AuthEventType, Set<AuthEventCallback>> = new Map();

  on(event: AuthEventType, callback: AuthEventCallback): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);

    // Retorna función para desuscribirse
    return () => {
      this.listeners.get(event)?.delete(callback);
    };
  }

  emit(event: AuthEventType): void {
    this.listeners.get(event)?.forEach((callback) => {
      try {
        callback();
      } catch (error) {
        console.error(`[AuthEvents] Error in listener for "${event}"`, error);
      }
    });
  }

  off(event: AuthEventType, callback: AuthEventCallback): void {
    this.listeners.get(event)?.delete(callback);
  }

  removeAllListeners(event?: AuthEventType): void {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }
}

export const authEvents = new AuthEventEmitter();

// Constantes para los tipos de eventos
export const AUTH_EVENTS = {
  SESSION_EXPIRED: 'session-expired' as AuthEventType,
  SESSION_REFRESHED: 'session-refreshed' as AuthEventType,
  SESSION_ERROR: 'session-error' as AuthEventType,
};
